"use strict";!function(e){if(e&&"undefined"!=typeof window){var t=document.createElement("style");t.setAttribute("type","text/css"),t.innerHTML=e,document.head.appendChild(t)}}(".header-table {\n  position: sticky;\n  top: 0;\n}");
//# sourceMappingURL=TableHead.scss.js.map
